export default {
  index: {
    text1: "招待",
    text2: "資産",
    text3: "請求書",
    text4: "専門エリア",
    text5: "一星規約",
    text6: "購読",
    text7: "二星規約",
    text8: "紹介",
    text9: "私たちのコミュニティに参加",
    text10: "上位アカウントをバインド",
    text11: "推薦者のアドレスを入力してください",
    text12: "確認",
    text13: "貢献激励池",
    text14: "残りの報酬",
    text15: "公開予定",
	text16: "パートナー",
  },
  wallet: {
    text1: "総資産価値",
    text2: "請求書",
    text3: "残高",
    text4: "引き出し",
    text5: "ホワイトリスト特典",
    text6: "IDO特典",
    text7: "購読",
 text8: "兑换",
 
 },
 dui :{
 	text1: "兑换白名单权益",
 
 },
  pawn: {
    text1: "収益は翌日18:18に決算されます。日次収益の70%はUSDTで、30%は相当するUESトークンで決算されます。UESの市場価値は3Uです。",
    text2: "購読",
    text3: "個",
    text4: "一星規約",
    text5: "毎日の収益",
    text6: "二星規約",
    text7: "三星規約",
    text8: "Plus規約"
  },
  zy: {
    text1: "収益中",
    text2: "期限切れ",
    text3: "数量",
    text5: "収益済み",
    text4: "購読日"
  },
  team: {
    text1: "現在のレベル",
    text2: "私の購読",
    text3: "サブエリア業績",
    text4: "私の推薦者",
    text5: "推薦者の購読",
    text6: "私のチーム",
    text7: "業績合計",
    text8: "サブエリア業績",
    text9: "チーム人数",
    text10: "私の推薦",
    text11: "購読数量",
    text12: "招待リンク"
  },
  withdrawal: {
    text1: "引き出し数量",
    text2: "入金",
    text3: "手数料",
    text4: "ウォレット残高",
    text5: "引き出し冻结",
    text6: "確認",
    text7: "引き出し数量を入力してください"
  },
  record: {
    text1: "タイプ",
    text2: "数量",
    text3: "時間"
  },
  header: {
    text1: 'もっと',
    text2: "推薦リンク",
    text3: "ホーム",
    text4: "ウォレット",
    text5: "購読",
    text6: "私の規約",
    text7: "私のチーム",
	text8: 'RLP白名单',
  },
  lan: {
    text1: '英語',
    text2: '簡体字中国語',
    text3: '繁体字中国語',
    text4: 'タイ語',
    text5: '韓国語',
    text6: '日本語',
    text7: 'ベトナム語'
  },
  tost: {
    text1: '公開予定',
    text2: 'コインの引き出し数量を入力してください',
    text3: '残高が不足しています',
    text4: 'コピーに成功しました',
	text5: '少なくとも 50 USDT を振り出してください（または：送金してください）',
  },
  rlp: {
  	text10: "RLP購入申し込み",
  	    text1: "ホワイトリスト100クォータで0.1BNB購入可",
  	    text2: "購入申し込み",
  	    text4: "購入定価",
  	    text3: "100クォータ/0.1BNB",
  	    text5: "BNB",
  	    text6: "マイホワイトリスト",
  	    text7: "購入申し込み"
  	
  },
  aitoken: {
    brand: 'GMIクラウド',
    connectWallet: 'ウォレット接続',
    language: '言語',
    tabs: {
      home: 'ホーム',
      business: '業務',
      orders: '注文',
      referral: '紹介',
    },
  },
}
